import MuiListItemText from '@mui/material/ListItemText';

type ListItemTextProps = {
  primary?: string;
  props?: any;
};

export default function ListItemText({
  primary,
  ...props
}: Readonly<ListItemTextProps>) {
  return <MuiListItemText primary={primary} {...props} />;
}
